// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "9c8c8acc3bd1af67c320119ed7315eb6" + ".js";
};